import React from 'react';
import {formatRoute} from 'react-router-named-routes';
import {ADD_NEW_STORE_PATH} from '@src/paths';
import TopBar from '@src/components/TopBar';
import {useTranslation} from 'react-i18next';
import {useTracking} from '@src/hooks/useTracking';
import trackingEvents from '@src/trackingEvents';

const ACHFormPage = () => {
  const {t} = useTranslation();
  const trackEvent = useTracking();

  return (
    <>
      <TopBar
        title={t('pages.AddNewStore.ACHFormPage.title')}
        breadcrumb={{
          label: t('pages.AddNewStore.breadcrumb'),
          accessibilityLabel: t('pages.AddNewStore.breadcrumb'),
          href: formatRoute(ADD_NEW_STORE_PATH),
          onClick: () =>
            trackEvent({
              url: window.location.href,
              page: 'AddNewStore',
              event: trackingEvents.AddNewStoreBackToAddNewStoreClicked,
            }),
        }}
      />
      <iframe
        id="JotFormIFrame-243534240821146"
        title="Onboarding ACH Form"
        onLoad={() => window.parent.scrollTo(0, 0)}
        allow="geolocation; microphone; camera; fullscreen"
        src="https://ezcater.jotform.com/243534240821146"
        frameBorder="0"
        style={{
          height: '100%',
          width: '100%',
          border: 'none',
        }}
      />
      <script src="https://ezcater.jotform.com/s/umd/latest/for-form-embed-handler.js" />
      <script
        dangerouslySetInnerHTML={{
          __html: `window.jotformEmbedHandler("iframe[id='JotFormIFrame-240305342013135']", "https://ezcater.jotform.com/")`,
        }}
      />
    </>
  );
};

export default ACHFormPage;
